<template lang="pug">
prompt(
  v-if="prompt",
  :ref="prompt.class",
  @customize-prompt="customizePrompt",
  @close-modal="closeModal",
  :parentData="{ prompt: prompt }"
)
</template>

<script>
import Prompt from "../../../prompt";

export default {
  components: {
    Prompt,
  },
  props: {
    parentData: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    prompt() {
      return this.parentData.prompt;
    },
  },

  methods: {
    customizePrompt(parent_el, arrow, card) {
      arrow.style.top = `${parent_el.offsetTop}px`;
      card.style.top = `${parent_el.offsetTop - 25}px`;
      arrow.style.left = `${parent_el.offsetLeft + 195}px`;
      card.style.left = `${parent_el.offsetLeft + 200}px`;

      this.$refs[this.prompt.class].showPrompt();
    },

    closeModal() {
      this.$emit("close-modal");
    },
  },
};
</script>

<style lang="scss">
.modal-form-card.ui-prompt-card.ppr-calendar-filters-all {
  width: 243px !important;
}
</style>
